export const blocks = [
  {
    id: 0,
    type: "earth",
    depth: 1,
    color: "green",
    palette: ["#7AAA22", "#62921D", "#5A8212", "#4B720E"]
  },
  {
    id: 1,
    type: "water",
    depth: 1,
    color: "blue",
    palette: ["#4EAFD6", "#2F97D6", "#3489CF", "#297FB3", "#276BAC"]
  },
  {
    id: 2,
    type: "stone",
    depth: 1,
    color: "gray",
    palette: ["#8F949C", "#807F84", "#798088", "#777E86", "#646970", "#5E6369"]
  },
  {
    id: 3,
    type: "lava",
    depth: 1,
    color: "red",
    palette: ["#FD9928", "#FC3E1D", "#FD8824", "#E13719"]
  }
];

export const generateBlockById = id => {
  const block = blocks.find(block => block.id === id);
  if (!block) throw new Error(`Block not found with id ${id}`);
  return { ...block };
};

export const BIOME_NAMES = {
  PLAINS: 0,
  ROCKY: 1,
  ARCHIPELLAGO: 2,
  LAKES: 3,
  VOLCANO: 4
};

export const biomes = [
  //PLAINS
  {
    earth: 5,
    water: 2,
    stone: 2,
    lava: 1
  },
  // ROCKY
  {
    earth: 3,
    water: 2,
    stone: 5,
    lava: 1
  },
  // ARCHIPELAGO
  {
    earth: 4,
    water: 6,
    stone: 1,
    lava: 0
  },
  // LAKES
  {
    earth: 5,
    water: 4,
    stone: 1,
    lava: 0
  },
  // VOLCANO
  {
    earth: 1,
    water: 0,
    stone: 2,
    lava: 2
  }
];
